var parent = require('../../stable/instance/slice');

module.exports = parent;



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js-pure/actual/instance/slice.js
// module id = 4071
// module chunks = 25